/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Rep_Max_ActualInputs */

const en_us2_exercise_sheet_rep_max_actual = /** @type {(inputs: Exercise_Sheet_Rep_Max_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const pt_br2_exercise_sheet_rep_max_actual = /** @type {(inputs: Exercise_Sheet_Rep_Max_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito`)
};

const es_419_exercise_sheet_rep_max_actual = /** @type {(inputs: Exercise_Sheet_Rep_Max_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho`)
};

const pt_pt2_exercise_sheet_rep_max_actual = /** @type {(inputs: Exercise_Sheet_Rep_Max_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito`)
};

const fr_fr2_exercise_sheet_rep_max_actual = /** @type {(inputs: Exercise_Sheet_Rep_Max_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réalisé`)
};

const de_de2_exercise_sheet_rep_max_actual = /** @type {(inputs: Exercise_Sheet_Rep_Max_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschafft`)
};

const it_it2_exercise_sheet_rep_max_actual = /** @type {(inputs: Exercise_Sheet_Rep_Max_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Exercise_Sheet_Rep_Max_ActualInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_rep_max_actual = /** @type {((inputs?: Exercise_Sheet_Rep_Max_ActualInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Rep_Max_ActualInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_rep_max_actual(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_rep_max_actual(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_rep_max_actual(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_rep_max_actual(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_rep_max_actual(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_rep_max_actual(inputs)
	return en_us2_exercise_sheet_rep_max_actual(inputs)
});
export { exercise_sheet_rep_max_actual as "exercise-sheet.rep_max_actual" }